import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "../data/tour";
import { openEnquire } from "./EnquireModal";

const LINKS = [
  { label: "Packages", href: "#pricing" },
  { label: "Inclusions", href: "#inclusions" },
  { label: "Reviews", href: "#reviews" },
  { label: "FAQ", href: "#faq" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="main-nav"
      className="fixed inset-x-0 top-0 z-50 border-b border-vine bg-jungle/85 backdrop-blur-md"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-10">
        <a href="#top" data-testid="nav-brand" className="flex items-center gap-2.5">
          <img src="/trekpanda-mascot.png" alt="TrekPanda panda" className="h-9 w-auto" />
          <span className="font-sans text-base font-extrabold tracking-[0.25em] text-cream">
            TREK<span className="text-marigold">PANDA</span>
          </span>
        </a>
        <nav className="hidden items-center gap-8 md:flex">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-xs uppercase tracking-[0.2em] text-sage transition-colors duration-300 hover:text-cream"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <button
            onClick={() => openEnquire()}
            data-testid="nav-book-button"
            className="hidden border border-marigold px-5 py-2 text-xs font-semibold uppercase tracking-[0.2em] text-marigold transition-colors duration-300 hover:bg-marigold hover:text-jungle sm:block"
          >
            Reserve a Seat
          </button>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-whatsapp-button"
            aria-label="WhatsApp TrekPanda"
            className="flex h-9 w-9 items-center justify-center border border-vine text-sage transition-colors duration-300 hover:border-marigold hover:text-marigold"
          >
            <MessageCircle size={16} />
          </a>
        </div>
      </div>
    </header>
  );
};
